import { CardContent } from "src/MarketDataComponents/Card";
import { Fragment } from "react";

export default function Tabs({tabs, selectedTabIndex, changeSelected}) {
    const TabButton = ({selected, label, index}) => {
        const className = `ajb-tab${selected ? ' ajb-tab-active' : ''}`;
        const tabName = label.split(' ')[0];
        
        return <span className={className} style={selected ? {display: 'inline-block'} : {padding: '0 28px'}}>
            <a href="" onClick={e => {
                e.preventDefault();
                changeSelected(index);
            }} data-testid={`${tabName.toLowerCase()}NewsLink`}>{label}</a>
        </span>
    }

    const displayTabs = () => {
        return tabs.map((item, i) => {
            const tabButtonProps = {
                selected: (selectedTabIndex == i),
                label: item.label,
                index: i
            };

            return <Fragment key={i}>
                <TabButton {...tabButtonProps} />
                {(i < tabs.length - 1) && <span className="ajb-tab-nav-divider light-text">|</span>}
            </Fragment>
        });
    }

    return <>
        <div className="ajb-grid ajb-tabs-nav">
            <div className="ajb-tabs-nav-wrapper">
                {displayTabs()}
            </div>
        </div>
        <div className="ajb-grid ajb-tabs-stage">
            <CardContent className="ajb-tabs-stage-content">
                {tabs[selectedTabIndex].content}
            </CardContent>
        </div>
    </>
}